import Auth from '~/api/auth'
import Content from '~/api/content'

export default defineNuxtPlugin(nuxtApp => {
  return {
    provide: {
      api: {
        auth: Auth(nuxtApp),
        content: Content(nuxtApp)
      }
    }
  }
})
